import React, { createContext, useContext } from 'react';
import { toast as toastify } from 'react-toastify';

const ToastContext = createContext();

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

export const ToastProvider = ({ children }) => {
  const toast = {
    success: (message, options = {}) => {
      toastify.success(message, {
        position: "top-right",
        autoClose: options.duration || 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        ...options
      });
    },
    error: (message, options = {}) => {
      toastify.error(message, {
        position: "top-right",
        autoClose: options.duration || 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        ...options
      });
    },
    warning: (message, options = {}) => {
      toastify.warning(message, {
        position: "top-right",
        autoClose: options.duration || 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        ...options
      });
    },
    info: (message, options = {}) => {
      toastify.info(message, {
        position: "top-right",
        autoClose: options.duration || 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        ...options
      });
    },
    // Utility for prompts (non-blocking alternative to confirm/alert)
    promise: (promise, messages) => {
      return toastify.promise(promise, messages, {
        position: "top-right"
      });
    }
  };

  return (
    <ToastContext.Provider value={toast}>
      {children}
    </ToastContext.Provider>
  );
};
